"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CONTACT_SALES = 'sales@ff.com';
/**
 * @deprecated move messages to clientMessages, some messages mismatch with ERROR_CODES
 */
exports.default = {
    'ERROR_CODE_-1': {
        en: 'Unknown error',
        zh: '未名错误'
    },
    ERROR_CODE_1: {
        en: 'Invalid login params.',
        zh: '用户名或密码错误，请重新输入'
    },
    ERROR_CODE_2: {
        en: "Log in failed, please try again later or contact ".concat(CONTACT_SALES, ".com for immediate support."),
        zh: '当前无法完成登录，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_3: {
        en: 'Incorrect credentials',
        zh: '用户名或密码错误，请重新输入'
    },
    ERROR_CODE_4: {
        en: "Server error, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '服务器错误，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_5: {
        en: "Registration failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成注册，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_6: {
        en: 'Email address already exists',
        zh: '电子邮件已经存在'
    },
    ERROR_CODE_7: {
        en: 'Phone number already exists',
        zh: '电话号码已经存在'
    },
    ERROR_CODE_8: {
        en: 'Phone number is not a valid number',
        zh: '无效电话号码'
    },
    ERROR_CODE_9: {
        en: "Registration failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成注册，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_10: {
        en: "We are unable to finish your request, please try again. If problem persists, contact sales@ff.com or 1.800.228.7702 for immediate support.",
        zh: '当前无法处理您的请求，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_11: {
        en: "We are unable to finish your request, please try again. If problem persists, contact sales@ff.com or 1.800.228.7702 for immediate support.",
        zh: '当前无法处理您的请求，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_12: {
        en: 'Invalid subscribe params',
        zh: '无效订阅参数'
    },
    ERROR_CODE_15: {
        en: 'Email does not exist',
        zh: '电子邮件不存在'
    },
    ERROR_CODE_16: {
        en: "Reset password failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成修改密码，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_17: {
        en: "Reset password failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成修改密码，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_18: {
        en: "Reset password failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成修改密码，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_19: {
        en: 'Cannot update profile because the email address/phone number already exists',
        zh: '因为输入的电子邮件已存在,无法更新您的资料'
    },
    ERROR_CODE_20: {
        en: 'The email provided is already subscribed.',
        zh: '该邮件已订阅'
    },
    ERROR_CODE_21: {
        en: 'Your account has been locked due to too many incorrect login attempts.  Please try again after 20 minutes or reset your password.',
        zh: '因为多次无效登录，该账号已被锁，请在20分钟后重试，或者重置密码'
    },
    ERROR_CODE_22: {
        en: 'Please enter a valid phone number',
        zh: '请输入正确的手机号'
    },
    ERROR_CODE_24: {
        en: 'Invalid verification code, please apply a new verification code',
        zh: '无效的验证码，请申请一个新的验证码'
    },
    ERROR_CODE_25: {
        en: 'Request verification code too often',
        zh: '验证码发送过于频繁，请稍后再试'
    },
    ERROR_CODE_26: {
        en: 'Invalid verification code, please apply a new verification code',
        zh: '无效的验证码，请申请一个新的验证码'
    },
    ERROR_CODE_29: {
        en: 'Phone number is not a valid number',
        zh: '无效电话号码'
    },
    ERROR_CODE_32: {
        en: 'Invalid verification code, please apply a new verification code',
        zh: '无效的验证码，请申请一个新的验证码'
    },
    ERROR_CODE_35: {
        en: "Reset password failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成修改密码，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_37: {
        en: 'This number does not exist',
        zh: '此号码尚未注册'
    },
    ERROR_CODE_41: {
        en: 'Invalid verification code, please apply a new verification code',
        zh: '无效的验证码，请申请一个新的验证码'
    },
    ERROR_CODE_42: {
        en: 'Login expired. Please log in again.',
        zh: '登录过期,请重新登录'
    },
    ERROR_CODE_43: {
        en: 'Password must be at least 8 characters and include at least one number, one uppercase letter, one lowercase letter, and one special character: !@#$%^&+=-',
        zh: ''
    },
    ERROR_CODE_44: {
        en: 'Unable to load account summary',
        zh: ''
    },
    ERROR_CODE_45: {
        en: "Failed to send verification code. Please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: ''
    },
    ERROR_CODE_46: {
        en: 'User is not logged in.',
        zh: '用户未登录'
    },
    ERROR_CODE_47: {
        en: 'Log in too frequently.',
        zh: '登录过于频繁'
    },
    ERROR_CODE_48: {
        en: 'Fail to delete account.',
        zh: '无法注销账号'
    },
    ERROR_CODE_49: {
        en: 'Fail to delete account due to actieve order.',
        zh: '无法注销账号，账号中存在未完成的订单.'
    },
    ERROR_CODE_51: {
        en: "Registration failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成注册，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_52: {
        en: "Registration failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成注册，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_53: {
        en: 'There was a problem subscribing to newsletter. Please try again.',
        zh: '订阅出错,请重试'
    },
    ERROR_CODE_54: {
        en: 'There was a problem subscribing to newsletter. Please try again.',
        zh: '订阅出错,请重试'
    },
    ERROR_CODE_55: {
        en: 'There was a problem subscribing to newsletter. Please try again.',
        zh: '订阅出错,请重试'
    },
    ERROR_CODE_56: {
        en: "We can't update your change now, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成资料修改，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_57: {
        en: "We can't update your change now, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成资料修改，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_101: {
        en: 'Failed to connect to FFID /subscribe endpoint',
        zh: '连不上FFID'
    },
    ERROR_CODE_102: {
        en: "We are unable to finish your request, please try again. If problem persists, contact sales@ff.com or 1.800.228.7702 for immediate support.",
        zh: '当前无法处理您的请求，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_103: {
        en: "Reset password failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成修改密码，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_104: {
        en: 'Reset password token already used or has expired',
        zh: '重置密码的密匙过期或者已经被使用'
    },
    ERROR_CODE_105: {
        en: 'Password must be at least 8 characters and include at least one number, one uppercase letter, one lowercase letter, and one special character: !@#$%^&+=-',
        zh: '密码需要至少8位长度，包含至少一位数字和字母'
    },
    ERROR_CODE_106: {
        en: "Reset password failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法处理您的请求，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_107: {
        en: "Reset password failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法处理您的请求，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_108: {
        en: 'The new password cannot be the same as the current password',
        zh: '新旧密码必须不等同'
    },
    ERROR_CODE_109: {
        en: 'The old password you entered does not match the one on record',
        zh: '旧密码错误'
    },
    ERROR_CODE_110: {
        en: 'Your previous login token has expired. Please try to log in again',
        zh: '登录过期,请重新登录'
    },
    ERROR_CODE_111: {
        en: 'There was a problem sending out SMS code. Please try again later.',
        zh: '发送验证码出错,请重试'
    },
    ERROR_CODE_150: {
        en: "Log in failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成登录，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_151: {
        en: 'There was a problem sending out email. Please try again later.',
        zh: '发送邮件出错,请重试'
    },
    ERROR_CODE_152: {
        en: 'There was a problem sending out email. Please try again later.',
        zh: '发送邮件出错,请重试'
    },
    ERROR_CODE_153: {
        en: 'There was a problem sending out email. Please try again later.',
        zh: '发送邮件出错,请重试'
    },
    ERROR_CODE_154: {
        en: 'There was a problem sending out email. Please try again later.',
        zh: '发送邮件出错,请重试'
    },
    ERROR_CODE_202: {
        en: 'There was a problem updating order status. Please try again later.',
        zh: '更改订单状态出错,请重试'
    },
    ERROR_CODE_203: {
        en: 'There was a problem updating order status. Please try again later.',
        zh: '更改订单状态出错,请重试'
    },
    ERROR_CODE_204: {
        en: 'There was a problem updating order status. Please try again later.',
        zh: '更改订单状态出错,请重试'
    },
    ERROR_CODE_206: {
        en: 'Token expired. Please log in again.',
        zh: '登录过期,请重新登录'
    },
    ERROR_CODE_207: {
        en: 'There was a problem updating order status. Please try again later.',
        zh: '更改订单状态出错,请重试'
    },
    ERROR_CODE_208: {
        en: 'There was a problem updating order status. Please try again later.',
        zh: '更改订单状态出错,请重试'
    },
    ERROR_CODE_209: {
        en: 'There was a problem updating order status. Please try again later.',
        zh: '更改订单状态出错,请重试'
    },
    ERROR_CODE_210: {
        en: 'There was a problem updating order status. Please try again later.',
        zh: '更改订单状态出错,请重试'
    },
    ERROR_CODE_211: {
        en: 'There was a problem updating order status. Please try again later.',
        zh: '更改订单状态出错,请重试'
    },
    ERROR_CODE_212: {
        en: 'Token expired. Please log in again.',
        zh: '登录过期,请重新登录'
    },
    ERROR_CODE_213: {
        en: "We are unable to finish your request, please try again. If problem persists, contact sales@ff.com or 1.800.228.7702 for immediate support.",
        zh: ''
    },
    ERROR_CODE_227: {
        en: 'Joining waitlist failed. Please try again later.',
        zh: '加入候补名单失败。 请稍后再试。'
    },
    ERROR_CODE_251: {
        en: 'Payment service is temporarily unavailable. Please try again later.',
        zh: '支付服务暂时不可用,请重试'
    },
    ERROR_CODE_252: {
        en: 'Payment failed. Please try again later.',
        zh: '支付出错,请重试'
    },
    ERROR_CODE_253: {
        en: 'Payment details cannot be retrieved. Please try again later.',
        zh: ''
    },
    ERROR_CODE_254: {
        en: 'Nothing changed',
        zh: '无改动'
    },
    ERROR_CODE_255: {
        en: 'Order does not exist for payment.',
        zh: '订单不存在'
    },
    ERROR_CODE_259: {
        en: "Your payment cannot be processed at this time. Please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: ''
    },
    ERROR_CODE_260: {
        en: 'Please verify your name and billing address match the information registered with your issuing bank.',
        zh: ''
    },
    ERROR_CODE_261: {
        en: 'Please check your card expiration date and try again.',
        zh: ''
    },
    ERROR_CODE_262: {
        en: 'Please check your card CVV and try again.',
        zh: ''
    },
    ERROR_CODE_263: {
        en: 'Please check your card number and try again.',
        zh: ''
    },
    ERROR_CODE_264: {
        en: 'This payment has been declined. Please contact your issuing bank for details or try another card.',
        zh: ''
    },
    ERROR_CODE_266: {
        en: "We are unable to finish your request, please try again. If problem persists, contact sales@ff.com or 1.800.228.7702 for immediate support.",
        zh: '当前无法处理您的请求，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_401: {
        en: "Log in failed, please try again later or contact ".concat(CONTACT_SALES, " for immediate support."),
        zh: '当前无法完成登录，请稍后再试或联系FFOnline@ff.com获取快速支持'
    },
    ERROR_CODE_999: {
        en: 'Data object validation error',
        zh: ''
    },
    ERROR_CODE_1100: {
        en: 'User not found or account is deactivated',
        zh: ''
    },
    ERROR_CODE_1101: {
        en: 'Email address already exists',
        zh: ''
    },
    ERROR_CODE_1102: {
        en: 'Username already exists',
        zh: ''
    },
    ERROR_CODE_1103: {
        en: 'Language key is not valid',
        zh: ''
    },
    ERROR_CODE_1104: {
        en: 'Password Error. Min 8 characters. At least one number and one character required.',
        zh: ''
    },
    ERROR_CODE_1105: {
        en: 'Change password can not use the original one',
        zh: ''
    },
    ERROR_CODE_1106: {
        en: 'Reset key already used or has expired',
        zh: ''
    },
    ERROR_CODE_1107: {
        en: 'Original password dose not match the one in record',
        zh: ''
    },
    ERROR_CODE_1108: {
        en: 'Avatar only supports image file type',
        zh: ''
    },
    ERROR_CODE_1109: {
        en: 'Email already verified. Do not need to send confirmation again',
        zh: ''
    },
    ERROR_CODE_1110: {
        en: 'Bad credential',
        zh: ''
    },
    ERROR_CODE_1111: {
        en: 'The deviceId is required',
        zh: ''
    },
    ERROR_CODE_1112: {
        en: 'Invalid client credential. Check authorization header',
        zh: ''
    },
    ERROR_CODE_1113: {
        en: 'The user is not created by the client identified from authorization header. The operation is prohibited',
        zh: ''
    },
    ERROR_CODE_1114: {
        en: 'Fail to send verify code to selected mobile number.',
        zh: ''
    },
    ERROR_CODE_1115: {
        en: 'Verify code fail. Please enter the code sent to you by sms.',
        zh: ''
    },
    ERROR_CODE_1116: {
        en: 'The verification code has expired. Please request a new one',
        zh: ''
    },
    ERROR_CODE_1117: {
        en: 'Email is required',
        zh: ''
    },
    ERROR_CODE_1118: {
        en: 'Phone number already exists',
        zh: ''
    },
    ERROR_CODE_1119: {
        en: 'Phone number is required',
        zh: ''
    },
    ERROR_CODE_1120: {
        en: 'Request verification code too often',
        zh: ''
    },
    ERROR_CODE_1121: {
        en: 'The code is invalid, please request a code through sms again',
        zh: ''
    },
    ERROR_CODE_1122: {
        en: 'The phone number is not verified. Please verify it first through sms before registration',
        zh: ''
    },
    ERROR_CODE_1123: {
        en: 'The phone number or email address already exists',
        zh: ''
    },
    ERROR_CODE_1124: {
        en: 'The uploading avatar functionality is not available now. Please try again later.',
        zh: ''
    },
    ERROR_CODE_1125: {
        en: 'Login is blocked for 24 hours due to 3 failed attempts.',
        zh: ''
    },
    ERROR_CODE_1126: {
        en: 'API rate limit exceeded.',
        zh: ''
    },
    ERROR_CODE_1127: {
        en: 'The phone number is not a valid number in US or China.',
        zh: ''
    },
    ERROR_CODE_1128: {
        en: 'The login username is not a valid email/mobile/username',
        zh: ''
    },
    ERROR_CODE_1129: {
        en: 'Reservation failed. Please try again later.',
        zh: ''
    },
    ERROR_CODE_1130: {
        en: 'Payment failed, please verify and try again.',
        zh: ''
    },
    ERROR_CODE_1131: {
        en: 'Event Signup failed.',
        zh: ''
    },
    ERROR_CODE_1132: {
        en: 'Configuration failed. Please try again later.',
        zh: ''
    },
    ERROR_CODE_5004: {
        en: 'Failed to make appointment. Please try again.',
        zh: ''
    },
    ERROR_CODE_5007: {
        en: 'Failed to make appointment. Please try again.',
        zh: ''
    },
    ERROR_CODE_5011: {
        en: "You've already enrolled in the waitlist before. We will contact you as soon as we have a spot available.",
        zh: ''
    },
};
